import React, { useState } from "react";
import swal from "sweetalert";
import { useQuery } from "seed/gql";
import { usePost } from "seed/api";
import l from "components/util/l";
import View from "components/collections/forms/Settings.view";

function Settings({
  flow,
  refetchCollections = () => { },
}) {

  const [activeCollectionId, setActiveCollectionId] = useState(null);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [defaultCollectionType, setDefaultCollectionType] = useState("TABLE");

  const reqCollections = useQuery(`{
    collections {
      id
      name
      settings
      uiSettings
    }
  }`, `(flow_id=${flow.id} AND is_active=true)`);

  const [callUpdate] = usePost("/collections/update_collection", {
    onCompleted: (data) => {
      reqCollections.refetch();
      refetchCollections();
      setActiveCollectionId(null);
    }
  });

  const [callDelete] = usePost("/collections/delete_collection", {
    onCompleted: (data) => {
      reqCollections.refetch();
      refetchCollections();
      setActiveCollectionId(null);
    }
  });

  const [saveIndexes] = usePost("/collections/reorder_collection", {
    onCompleted: () => {
      reqCollections.refetch();
      refetchCollections();
    }
  });

  const onMoveUp = (index) => {

    if (index === 0) return;

    const prevCollection = collections[index - 1];
    const collection = collections[index];

    const newIndex = prevCollection.settings.index ?? index - 1;
    const newIndexUp = collection.settings.index ?? index + 1;

    const newNodesIndexes = collections.map((auxCollection, i) => {
      if (auxCollection.id === prevCollection.id)
        return { ...auxCollection, index: newIndexUp };
      else if (auxCollection.id === collection.id)
        return { ...auxCollection, index: newIndex };
      else return { ...auxCollection, index: auxCollection.settings.index ?? i };
    });

    saveIndexes({ indexes: newNodesIndexes });

  }

  const onMoveDown = (index) => {

    if (index === collections.length - 1) return;

    const nextCollection = collections[index + 1];
    const collection = collections[index];

    const newIndex = nextCollection.settings.index ?? index + 1;
    const newIndexUp = collection.settings.index ?? index - 1;

    const newNodesIndexes = collections.map((auxCollection, i) => {
      if (auxCollection.id === nextCollection.id)
        return { ...auxCollection, index: newIndexUp };
      else if (auxCollection.id === collection.id)
        return { ...auxCollection, index: newIndex };
      else return { ...auxCollection, index: auxCollection.settings.index ?? i };
    });

    saveIndexes({ indexes: newNodesIndexes });

  }

  const onEdit = (id) => {
    setIsEditModalOpen(true);
    setActiveCollectionId(id);
  }

  const onDelete = (id) => {
    swal({
      title: l("Eliminar registro%CA044"),
      icon: "warning",
      text: l("¿Estás seguro que desea eliminar este registro?%CA045"),
      buttons: {
        delete: {
          text: l("Eliminar%GA001"),
          className: "swal-button swal-button--cancel btn-danger px-2 w-100",
        },
        exit: {
          text: l("Cancelar%GA009"),
          className: "swal-button swal-button--cancel btn-secondary px-2 w-100",
        }
      },
    }).then((response) => {
      if (response == "delete")
        callDelete({ collection_id: id });
    });
  }

  const onChangeVisibility = (collection_id, is_hidden) =>
    callUpdate({ collection_id, settings: { is_hidden } });

  let collections = Object.assign([], reqCollections.data.collections);
  collections = collections.sort((a, b) => {
    if (a.settings.index != null && b.settings.index != null)
      return a.settings.index - b.settings.index;
    else
      return b.id - a.id;
  });

  return <View
    flow={flow}
    collections={collections}
    activeCollectionId={activeCollectionId}
    defaultCollectionType={defaultCollectionType}
    isCreateModalOpen={isCreateModalOpen}
    isEditModalOpen={isEditModalOpen}
    setDefaultCollectionType={setDefaultCollectionType}
    setIsCreateModalOpen={setIsCreateModalOpen}
    setIsEditModalOpen={setIsEditModalOpen}
    onMoveUp={onMoveUp}
    onMoveDown={onMoveDown}
    onEdit={onEdit}
    onDelete={onDelete}
    onChangeVisibility={onChangeVisibility}
    refetchCollections={refetchCollections}
  />;

}

export default Settings;